import store from '../store';
export const login = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login.vue'),
    meta: {
      hiddenNav: true
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  }
];
